import { Shuffle, Loader2 } from "lucide-react";
import { THEMES } from "@/lib/api";
import { ThemeIcon } from "@/components/ThemeIcon";

export function ThemePicker({ busy, onPick }) {
  return (
    <section className="space-y-3 rise rise-2" data-testid="home-theme-picker">
      <p className="text-xs font-bold uppercase tracking-widest text-slate-500">
        {busy ? "Préparation de la leçon…" : "Choisir le thème de la prochaine leçon"}
      </p>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {THEMES.map((t) => (
          <button
            key={t}
            disabled={!!busy}
            onClick={() => onPick(t)}
            data-testid={`home-theme-${t}`}
            className="h-20 rounded-xl bg-white border-2 border-slate-200 hover:border-orange-500 hover:text-orange-600 flex flex-col items-center justify-center gap-1 text-xs font-bold uppercase transition-colors disabled:opacity-50"
          >
            {busy === t ? <Loader2 className="w-6 h-6 animate-spin text-orange-500" /> : <ThemeIcon theme={t} />}
            {t}
          </button>
        ))}
        <button
          disabled={!!busy}
          onClick={() => onPick(null)}
          data-testid="home-theme-surprise"
          className="h-20 rounded-xl bg-slate-900 text-amber-400 hover:bg-slate-800 flex flex-col items-center justify-center gap-1 text-xs font-bold uppercase transition-colors disabled:opacity-50 col-span-3 sm:col-span-2"
        >
          {busy === "surprise" ? <Loader2 className="w-6 h-6 animate-spin" /> : <Shuffle className="w-6 h-6" />}
          Surprise
        </button>
      </div>
    </section>
  );
}
